import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function SelectedRolePermissions () {
  const selectedPermissions = useValue('list_of_permissions')

  return selectedPermissions.map(slug => <input key={slug} name='selected_permissions[]' type='hidden' value={slug} />)
}
